<app-home-hero></app-home-hero>
<app-exclusive-benefits></app-exclusive-benefits>
<!-- <app-weekly-offers></app-weekly-offers> -->
<app-more-offers></app-more-offers>
<app-why-unipay></app-why-unipay>
<app-cash-advance></app-cash-advance>
<app-phone-assistance-banner></app-phone-assistance-banner>
<app-faq-banner></app-faq-banner>
<app-whatsapp-section></app-whatsapp-section>
